import React from 'react';
import { useTranslation } from 'react-i18next';
import './Services.css';
import Seo from '../Components/Seo';


export default function Services() {
    const { t } = useTranslation();
    return (
        <div className="Servicespage">
            <Seo
                title="Pyörähuolto ja korjaus"
                description="Kempeleen Pyöräpaja tarjoaa polkupyörien huolto- ja korjauspalveluja, kuten perushuollot, sisäkumien vaihdot ja muut yleiset korjaukset."
                path="/services"
            />
            <div className='Servicespage-content'>
                <div className="service-card">
                    <h2 className='text'>{t('services.maintenance')}</h2>
                    <h4>{t('services.basicMaintenance')}</h4>
                    <ul>
                        <li><span>{t('services.singleSpeed')}</span> <span>50€</span></li>
                        <li><span>{t('services.hubGears')}</span> <span>60€</span></li>
                        <li><span>{t('services.derailleurGears')}</span> <span>80€</span></li>
                    </ul>
                    <h4 className='text'>{t('services.basicMaintenanceIncludes')}:</h4>
                    <ul className="included-list">
                        <li>{t('services.bikeWash')}</li>
                        <li>{t('services.chainCleaningAndLubrication')}</li>
                        <li>{t('services.wheelStraightening')}</li>
                        <li>{t('services.cableCheck')}</li>
                        <li>{t('services.gearAndBrakeAdjustment')}</li>
                        <li>{t('services.hubAndSteeringBearingCheck')}</li>
                        <li>{t('services.boltTightening')}</li>
                    </ul>
                    <p>{t('services.partsReplacementChargedSeparately')}</p>
                    <p>{t('services.limitedElectricBikeMaintenance')}</p>
                </div>

                <div className="service-card">
                    <h2 className='text'>{t('services.repairs')}</h2>
                    <h4>{t('services.examples')}:</h4>
                    <ul>
                        <li>
                            <span>{t('services.outerTubeReplacement')}:</span>
                            <ul>
                                <li><span>{t('services.frontOrRearWheel')}</span> <span>10€</span></li>
                                <li><span>{t('services.detachableWheel')}</span> <span>8€</span></li>
                            </ul>
                        </li>
                        <li><span>{t('services.innerTubeReplacementOrPatch')}</span> <span>10€</span></li>
                        <li><span>{t('services.brakePadReplacement')}</span> <span>10€</span></li>
                        <li><span>{t('services.chainReplacement')}</span> <span>10€</span></li>
                        <li><span>{t('services.cableReplacement')}</span> <span>10€</span></li>
                        <li><span>{t('services.mudguardInstallation')}</span> <span>15-30€</span></li>
                        <li><span>{t('services.frontBasketInstallation')}</span> <span>15€</span></li>
                        <li><span>{t('services.kickstandInstallation')}</span> <span>10€</span></li>
                        <li><span>{t('services.saddleReplacement')}</span> <span>5€</span></li>
                        <li><span>{t('services.pedalReplacement')}</span> <span>5€</span></li>
                        <li><span>{t('services.handlebarReplacement')}</span> <span>10€</span></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}